<form [formGroup]="registerForm" (ngSubmit)="register()" novalidate>
  <h1 class="text-center auth-heading">
    <a [routerLink]="['/']" class="inline-block">
      <img src="assets/layout/images/wtg-logo-transparent-white.webp" alt="wtg watch this garage logo" class="app-logo">
    </a>
    <small>{{ 'auth.registration.title' | translate }}</small>
  </h1>
  <div class="col-12 p-fluid">
    <div class="p-float-label p-input-icon-left">
      <i class="pi pi-user"></i>
      <input pInputText minLength="6" maxLength=20 data-error=" " data-success=" " type="text" id="username"
             class="form-control" formControlName="username">
      <label for="username">{{ 'auth.registration.username' | translate }}</label>
    </div>
    <div class="app-form-error"
         *ngIf="registerForm.controls['username'].invalid && registerForm.controls['username'].touched">
      <p
        *ngIf="registerForm.controls['username'].errors.required">{{ 'auth.registration.validation.required_name' | translate }}</p>
      <p
        *ngIf="registerForm.controls['username'].errors.minlength">{{ 'auth.registration.validation.min' | translate }}</p>
      <p
        *ngIf="registerForm.controls['username'].errors.maxlength">{{ 'auth.registration.validation.max' | translate }}</p>
      <p
        *ngIf="registerForm.controls['username'].errors.custom">{{ registerForm.controls['username'].errors.custom }}</p>
    </div>
  </div>

  <div class="col-12 p-fluid">
    <div class="p-float-label p-input-icon-left">
      <i class="pi pi-envelope"></i>
      <input pInputText data-error=" " data-success=" " type="email" id="email" class="form-control"
             formControlName="email">
      <label for="email">{{ 'auth.registration.email' | translate }}</label>
    </div>
    <div class="app-form-error"
         *ngIf="registerForm.controls['email'].invalid && registerForm.controls['email'].touched">
      <p
        *ngIf="registerForm.controls['email'].errors.required">{{ 'auth.registration.validation.required_email' | translate }}</p>
      <p *ngIf="registerForm.controls['email'].errors.email">{{ 'auth.registration.validation.email' | translate }}</p>
      <p *ngIf="registerForm.controls['email'].errors.custom">{{ registerForm.controls['email'].errors.custom }}</p>
    </div>
  </div>

  <div formGroupName="password">
    <div class="col-12 p-fluid">
      <div class="p-float-label p-input-icon-left">
        <i class="pi pi-key"></i>
        <input pInputText minLength="6" maxLength="50" data-error=" " data-success=" " type="password"
               id="password"
               class="form-control" formControlName="first" autocomplete="new-password">
        <label for="password">{{ 'auth.registration.password' | translate }}</label>
      </div>
      <div class="app-form-error"
           *ngIf="registerForm.controls['password'].invalid && registerForm.controls['password'].touched">
        <p *ngIf="registerForm.controls['password']['controls']['first'].errors?.required">
          {{ 'auth.registration.validation.password_required' | translate }}</p>
        <p *ngIf="registerForm.controls['password']['controls']['first'].errors?.minlength">
          {{ 'auth.registration.validation.password_min' | translate }}</p>
        <p *ngIf="registerForm.controls['password']['controls']['first'].errors?.maxlength">
          {{ 'auth.registration.validation.password_max' | translate }}</p>
        <p *ngIf="registerForm.controls['password']['controls']['second'].errors?.required">
          {{ 'auth.registration.validation.password_retyped' | translate }}</p>
        <p *ngIf="registerForm.controls['password']['controls']['first'].errors?.custom">
          {{ registerForm.controls['password']['controls']['first'].errors['custom'] }}</p>
      </div>
    </div>

    <div class="col-12 p-fluid">
            <span class="p-float-label p-input-icon-left">
              <i class="pi pi-replay prefix"></i>
              <input pInputText minLength="6" maxLength="50" data-error=" " data-success=" " type="password"
                     id="retyped-password" class="form-control" formControlName="second" autocomplete="new-password">
              <label for="retyped-password">{{ 'auth.registration.validation.password_retype' | translate }}</label>
            </span>
      <div class="app-form-error"
           *ngIf="registerForm.controls['password'].invalid && registerForm.controls['password']['controls']['second'].touched">
        <p *ngIf="registerForm.controls['password']['controls']['second'].errors?.matchPassword">
          {{ 'auth.registration.validation.password_match' | translate }}
        </p>
        <p
          *ngIf="registerForm.controls['password']['controls']['second'].errors?.custom">{{ registerForm.controls['password']['controls']['second'].errors.custom }}</p>
      </div>
    </div>

  </div>
  <div class="col-12 p-fluid" *ngIf="showAccessCode">
    <div class="width-100 flex justify-content-center align-items-center mb-2">
      <p-inputOtp [formControl]="registerForm.controls['accessCode']" [length]="6"></p-inputOtp>
    </div>
    <small>{{ 'auth.registration.access_code_help' | translate }}</small>
    <div class="app-form-error"
         *ngIf="registerForm.controls['accessCode'].invalid && registerForm.controls['accessCode'].touched">
      <p *ngIf="registerForm.controls['accessCode'].errors?.required">
        {{ 'auth.registration.validation.access_code_required' | translate }}
      </p>
      <p *ngIf="registerForm.controls['accessCode'].errors?.pattern">
        {{ 'auth.registration.validation.access_code_format' | translate }}
      </p>
      <p *ngIf="registerForm.controls['accessCode'].errors?.custom">
        {{ registerForm.controls['accessCode'].errors.custom | translate }}
      </p>
    </div>
  </div>
  <div class="col-12 p-fluid">
    <div class="flex align-items-start gap-2">
      <p-checkbox [binary]="true" [formControl]="registerForm.controls['terms']"></p-checkbox>
      <div class="line-height-3">
        <span>{{ 'auth.registration.accept_legal_prefix' | translate }} </span>
        <a class="privacy-no-auth" [routerLink]="[termsRoute]" target="_blank">{{ 'auth.registration.terms' | translate }}</a>
        <span> {{ 'auth.registration.accept_legal_join' | translate }} </span>
        <a class="privacy-no-auth" [routerLink]="[privacyPolicyRoute]" target="_blank">{{ 'auth.registration.privacy_policy' | translate }}</a>
      </div>
    </div>
    <div class="app-form-error"
         *ngIf="registerForm.controls['terms'].invalid && registerForm.controls['terms'].touched">
      <p
        *ngIf="registerForm.controls['terms'].errors.required">{{ 'auth.registration.validation.accept_terms' | translate }}</p>
      <p *ngIf="registerForm.controls['terms'].errors.custom">{{ registerForm.controls['terms'].errors.custom | translate }}</p>
    </div>
  </div>

  <div class="col-12 p-fluid">
    <button pButton pRipple
            type="submit"
            icon="pi pi-plus"
            iconPos="left"
            class="auth-action--primary"
            [disabled]="registerForm.invalid"
            [label]="'auth.registration.button.register' | translate">
    </button>
  </div>
  <div class="col-12 p-fluid">
    <button pButton pRipple
            type="button"
            icon="pi pi-arrow-left"
            iconPos="left"
            class="auth-action--back"
            [routerLink]="['/login']"
            [label]="'common.button.back' | translate">
    </button>
  </div>
</form>
